<template>
  <div>
    <div class="tab_con m_flex_box flex_vb">
      <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
        >每日任务</span
      >
      <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
        >每周任务</span
      >
      <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
        >一次性任务</span
      >
    </div>
    <div class='integral_task'>
      <div class="integral_task_one">
        <div class="task_1"></div>
        <div class="task_2">
          <div>收藏1个新房项目</div>
          <div>每天收藏一个新房项目</div>
          <div class="task_2_middle">
            <div class="step">
              <div></div>
            </div>
            <div class="num">0/1</div>
          </div>
        </div>
        <div class="task_3">+2</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab: 0,
    };
  },
  methods: {
    changeTab(num) {
      this.tab = num;
    },
  },
};
</script>
<style lang="less" scoped>
.tab_con {
  height: 1rem;
  background-color: #fff;
  display: flex;
  z-index: 9;
  span {
    flex: 1;
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    position: relative;
    text-align: center;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      // margin-left: -0.2rem;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 0.7rem;
      height: 0.04rem;
    }
  }
}
.integral_task {
  padding: 0.2rem 0.3rem;
  & > p {
    font-size: 0.3rem;
    font-weight: 900;
  }
  .integral_task_one {
    display: flex;
    margin-top: 0.1rem;
    .task_1 {
      flex: 0 1 20%;
    }
    .task_2 {
      flex: 0 1 70%;
      & > div {
        margin-top: 0.1rem;
      }
      .task_2_middle {
        align-items: center;
        display: flex;
        .step {
          width: 70%;
          height: 0.07rem;
          position: relative;
          background: #cfcfcf;
          overflow: hidden;
          border-radius: 5%;
          div {
            width: 50%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: #99ccff;
          }
        }
        .num {
          margin-left: 0.3rem;
        }
      }
    }
    .task_3 {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      font-weight: 900;
      flex: 0 1 10%;
      color: #ff0000;
    }
  }
  .more {
    margin-top: 0.5rem;
    font-weight: 900;
    text-align: center;
  }
}
</style>